import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _pt from "prop-types";
import React from 'react';

var Element = function (_React$PureComponent) {
  _inherits(Element, _React$PureComponent);

  function Element() {
    _classCallCheck(this, Element);

    return _possibleConstructorReturn(this, _getPrototypeOf(Element).apply(this, arguments));
  }

  _createClass(Element, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attributes = _this$props.attributes,
          children = _this$props.children,
          selfClose = _this$props.selfClose,
          Tag = _this$props.tagName;
      return selfClose ? React.createElement(Tag, attributes) : React.createElement(Tag, attributes, children);
    }
  }]);

  return Element;
}(React.PureComponent);

_defineProperty(Element, "propTypes", {
  attributes: _pt.any,
  children: _pt.node,
  selfClose: _pt.bool,
  tagName: _pt.any.isRequired
});

_defineProperty(Element, "defaultProps", {
  attributes: {},
  children: null,
  selfClose: false
});

export { Element as default };